import { DateTime } from 'luxon';
import {
  AgreementDocument,
  CustomAgreementType,
  LegalDocument,
  SignatureRequirementType,
  UserAgreement,
  UserAgreementRecord,
} from './agreement-document';

export namespace AgreementDocumentsParsers {
  export type UserAgreementJson = {
    agreementDocument: AgreementDocumentJson;
    userAgreement?: UserAgreementRecordJson;
  };

  export type AgreementDocumentJson = {
    legalDocument: LegalDocumentJson;
    customAgreementType: CustomAgreementTypeJson;
  };

  export type UserAgreementRecordJson = {
    id: number;
    userId: number;
    signedOn: string;
    legalDocumentId: number;
    customAgreementTypeId: number;
    orderId?: number;
  };

  export type LegalDocumentJson = {
    id: number;
    document?: string;
    contentPageId: number;
    date: string;
    customAgreementTypeId: number;
    hashDocument: string;
    title: string;
    excerpt: string;
    content: string;
    code: string;
    usePdf: boolean;
    pdfFile?: string;
  };

  export type CustomAgreementTypeJson = {
    id: number;
    name: string;
    displayText: string;
    signatureRequirementType: SignatureRequirementType;
    isDownloadable: boolean;
  };

  export function toUserAgreement(input: UserAgreementJson): UserAgreement {
    return {
      agreementDocument: toAgreementDocument(input.agreementDocument),
      userAgreement: input.userAgreement ? toUserAgreementRecord(input.userAgreement) : undefined,
    };
  }

  export function toAgreementDocument(input: AgreementDocumentJson): AgreementDocument {
    return {
      legalDocument: toLegalDocument(input.legalDocument),
      customAgreementType: toCustomAgreementType(input.customAgreementType),
    };
  }

  export function toUserAgreementRecord(input: UserAgreementRecordJson): UserAgreementRecord {
    return {
      ...input,
      signedOn: DateTime.fromISO(input.signedOn),
    };
  }

  export function toLegalDocument(input: LegalDocumentJson): LegalDocument {
    return {
      ...input,
      date: DateTime.fromISO(input.date),
    };
  }

  export function toCustomAgreementType(input: CustomAgreementTypeJson): CustomAgreementType {
    return {
      ...input,
    };
  }
}
